/* ═══════════════════════════════════════════════════
   EXPLORE BY LOCATION — Homepage Section
   Loads location cards from CDN-cached pg-map-data.json.
   Lazy: the 400 KB+ JSON is only fetched once the section
   comes within 600px of the viewport, so homepage LCP is
   not taxed for users who never scroll that far.
   ═══════════════════════════════════════════════════ */
(function () {
  'use strict';

  var track = document.querySelector('.pghm-track');
  if (!track) return;

  var src = track.dataset.src;
  if (!src) return;

  // Country code → flag emoji
  function flag(code) {
    if (!code || code.length !== 2) return '';
    return String.fromCodePoint(0x1f1e6 + code.charCodeAt(0) - 65, 0x1f1e6 + code.charCodeAt(1) - 65);
  }

  function esc(s) {
    // ⚠ Explicit replaces, NOT `d.textContent = s; return d.innerHTML`.
    //
    // The textContent trick escapes &, < and > and leaves the DOUBLE QUOTE alone,
    // because a quote is not special in text content. Every use of esc() in this file
    // interpolates into an ATTRIBUTE value, where the quote is the one character that
    // matters — it closes the attribute early and everything after it becomes markup.
    // Same implementation as assets/pg-card.js, which had it right.
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function hydrate(data) {
    var locations = data.locations || [];
    if (!locations.length) {
      track.innerHTML = '';
      return;
    }

    locations.sort(function (a, b) { return (b.productCount || 0) - (a.productCount || 0); });
    var top = locations.slice(0, 12);

    var section = document.getElementById('pg-explore-locations');
    if (section) {
      var setVal = function (key, val) {
        var el = section.querySelector('[data-stat="' + key + '"]');
        if (el) el.textContent = val;
      };
      setVal('products', (data.totalProducts || 0).toLocaleString());
      setVal('locations', data.totalLocations || locations.length);
      setVal('countries', data.countryCounts ? Object.keys(data.countryCounts).length : 0);
    }

    var html = '';
    for (var i = 0; i < top.length; i++) {
      var loc = top[i];
      // The top-12 feed now carries each area's COLLECTION url (the nightly
      // sync writes it). Fall back to the map page, never to /a/locations/* —
      // those app-proxy pages are retired.
      var href = loc.url || '/pages/puzzle-map';
      var img = '';
      if (loc.products && loc.products[0] && loc.products[0].image) {
        var join = loc.products[0].image.indexOf('?') >= 0 ? '&' : '?';
        img = loc.products[0].image + join + 'width=400';
      }

      html += '<a class="pghm-card" href="' + esc(href) + '">';
      html += '<div class="pghm-card-img">';
      if (img) {
        html += '<img src="' + esc(img) + '" alt="' + esc(loc.name) + ' jigsaw puzzles" loading="lazy" width="400" height="300">';
      }
      html += '<span class="pghm-card-badge">' + loc.productCount + ' puzzles</span>';
      html += '</div>';
      html += '<div class="pghm-card-body">';
      html += '<div class="pghm-card-name"><span class="pghm-card-flag">' + flag(loc.country) + '</span> ' + esc(loc.name) + '</div>';
      html += '<div class="pghm-card-count">' + loc.productCount + ' puzzle' + (loc.productCount !== 1 ? 's' : '') + '</div>';
      html += '</div></a>';
    }

    track.innerHTML = html;

    var wrapper = track.closest('.pg-carousel-wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.pg-carousel-arrow').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var dir = arrow.classList.contains('pg-carousel-arrow--left') ? -1 : 1;
          track.scrollBy({ left: dir * 420, behavior: 'smooth' });
        });
      });
    }
  }

  var fetched = false;
  function fetchAndHydrate() {
    if (fetched) return;
    fetched = true;
    fetch(src, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(hydrate)
      .catch(function () { track.innerHTML = ''; });
  }

  // Lazy trigger: fetch when section scrolls within 600px of viewport.
  if ('IntersectionObserver' in window) {
    var section = document.getElementById('pg-explore-locations');
    var target = section || track;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          fetchAndHydrate();
          io.disconnect();
        }
      });
    }, { rootMargin: '600px 0px' });
    io.observe(target);
  } else {
    // Old browsers: wait for idle, then fetch.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fetchAndHydrate, { timeout: 4000 });
    } else {
      setTimeout(fetchAndHydrate, 2000);
    }
  }
})();
